import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!

  return (_ctx.state.carregando)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_ctx.props.varias)
          ? (_openBlock(), _createBlock(_component_a_select, {
              key: 0,
              class: "ss-tamanho-completo",
              onChange: _ctx.change,
              value: _ctx.computedCodigosSelecionados,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigosSelecionados) = $event)),
              mode: "multiple",
              placeholder: _ctx.props.placeholder,
              optionFilterProp: "label",
              options: _ctx.state.listaRelacoesPessoa,
              disabled: _ctx.props.disabled
            }, null, 8, ["onChange", "value", "placeholder", "options", "disabled"]))
          : (_openBlock(), _createBlock(_component_a_select, {
              key: 1,
              class: "ss-tamanho-completo",
              onChange: _ctx.change,
              value: _ctx.computedCodigoSelecionado,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
              placeholder: _ctx.props.placeholder,
              optionFilterProp: "label",
              options: _ctx.state.listaRelacoesPessoa,
              disabled: _ctx.props.disabled
            }, null, 8, ["onChange", "value", "placeholder", "options", "disabled"]))
      ]))
}